import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { ProfileTypeService } from '../profile-type.service';
import { ProfileType } from '../steel-profile';

@Component({
    selector: 'app-profile-type-detail',
    templateUrl: './profile-type-detail.component.html',
    styleUrls: ['./profile-type-detail.component.css']
})

export class ProfileTypeDetailComponent implements OnInit {
  profileTypeId: number;
  profileType: ProfileType;
  profileTypeForm: AbstractControl;
  families = ProfileType.getFamilies();
  @Input() profileTypes;
  @Output() updateListProfileTypes = new EventEmitter();
  @Output() hideFormProfileTypes = new EventEmitter();

  constructor(private fb: FormBuilder,
              private profileTypeService: ProfileTypeService) {

      this.profileTypeForm = this.fb.group({
          profile_type: ['', [Validators.required]],
          name: ['', [Validators.required]],
          family: ['', [Validators.required]]
      });
  }

  ngOnInit() {
    this.profileTypeForm.valueChanges.subscribe(values => this.changed(values));
  }

  changed(values){
    if(this.profileTypeId != values.profile_type && values.profile_type!= null){
      this.profileTypeService.get(values.profile_type).subscribe(data => {
        this.profileType = data;
        this.profileTypeId = data.id;
        // this.profileTypeForm = Object.assign({}, this.profileType);
        this.resetForm();
      });
    } else if(this.profileType != null) {
      this.profileType.name = values.name;
      this.profileType.family = values.family;
    }

  }

  resetForm() {
    this.profileTypeForm.reset({
        profile_type: this.profileType.id,
        name: this.profileType.name,
        family: this.profileType.family,
    });
  }

  cancelEdition() {
      // this.router.navigate(['/perfiles']);
      this.profileTypeForm.reset();
      this.profileType = null;
      this.hideFormProfileTypes.emit();
  }

  update() {
      this.profileTypeService.update(this.profileType).subscribe(
          (res) => {
            // this.router.navigate(['/perfiles']);
            this.updateListProfileTypes.emit();
            this.cancelEdition();
            this.hideFormProfileTypes.emit();
          }
      );
  }

  canUpdate(): boolean {
      return this.profileTypeForm.valid;
  }

  delete() {
    this.profileTypeService.delete(this.profileType).subscribe(
        (res) => {
          // this.router.navigate(['/perfiles']);
          this.updateListProfileTypes.emit();
          this.cancelEdition();
          this.hideFormProfileTypes.emit();
        }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/profile-type-detail/profile-type-detail.component.ts